import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import dayjs from "dayjs";

import { keyframes } from "@emotion/react";

import flyer from "../assets/images/flyer.png";
import flyer2 from "../assets/images/flyer2.png";
import logoWithBrandmark from "../assets/logos/Logo summer of sound.png";

const bounce = keyframes`
0% {
        transform: scale(1);
    }
    10% {
        transform: scale(1.02);
    }
    20% {
        transform: scale(1);
    }
    30% {
        transform: scale(1.02);
    }
    40% {
        transform: scale(1);
    }*/
    50% {
        transform: scale(1);
    }
    60% {
        transform: scale(1);
    }
    70% {
        transform: scale(1);
    } */
    100% {
        transform: scale(1);
    }
`;

function CircularProgressWithLabel(props) {
  const endDate = dayjs("2023-07-29T20:00:00");
  const now = dayjs(new Date());

  const difference = endDate.diff(now, true);

  const days = endDate.diff(now, "day") < 0 ? 0 : endDate.diff(now, "day");
  const hours =
    endDate.diff(now, "hour") - days * 24 < 0
      ? 0
      : endDate.diff(now, "hour") - days * 24;
  const minutes =
    endDate.diff(now, "minute") - days * 24 * 60 - hours * 60 < 0
      ? 0
      : endDate.diff(now, "minute") - days * 24 * 60 - hours * 60;

  const formatedDays = days < 10 ? `0${days}` : days;
  const formatedHours = hours < 10 ? `0${hours}` : hours;
  const formatedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const seconds = dayjs(difference).format("ss");

  const width = window.innerWidth;
  const height = window.innerHeight;
  let circleSize;

  if (width < height) {
    circleSize = width * 0.8;
  } else {
    circleSize = height * 0.8;
  }

  return (
    <Box
    // display="flex"
    // flexDirection="column"
    // alignItems="center"
    // justifyContent="space-around"
    >
      <Box
        // borderRadius={5}
        display="flex"
        justifyContent="center"
        alignItems="center"
        // marginBottom={4}
      >
        {/* <Typography
          sx={{ typography: { lg: 'h3', md: 'h4', sm: 'h5', xs: 'h6' } }}
          color="secondary"
        >
          {`${formatedDays} - ${formatedHours} : ${formatedMinutes} : ${seconds}`}
        </Typography> */}
      </Box>
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        {/* <CircularProgress
          color="secondary"
          thickness={1}
          size={circleSize}
          variant="determinate"
          value={(seconds / 60) * 100}
        /> */}
        <Box
          sx={{
            // top: 0,
            // left: 0,
            // bottom: 0,
            // right: 0,
            // position: "absolute",
            display: "flex",
            // flexDirection: 'row',
            alignItems: "center",
            justifyContent: "center",
            // backgroundColor: 'orange'
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              animation: `${bounce} 1s ease infinite`,
              position: "relative",
              cursor: "pointer",
              // backgroundColor: "orange",
              overflow: "hidden",
            }}
            onClick={() =>
              window.open("https://www.instagram.com/summer_of_sound/#")
            }
          >
            <Box
              component="img"
              sx={{
                width: "100%",
                height: "100%",
                maxHeight: "500px",
                transform: "scale(1.8)",
                // boxShadow: 1,
                borderRadius: 2,
                // animation: `${bounce} 1s ease infinite`,
              }}
              className="logo"
              src={logoWithBrandmark}
            />

            <Box
              sx={{
                width: "20%",
                height: "5%",
                // backgroundColor: 'white',
                position: "absolute",
                top: "75%",
                left: "28%",
                transform: "rotate(330deg)",
              }}
            >
              <svg viewBox="0 0 85 25">
                <text x="0" y="15" fill="white" fontWeight="bold">
                  Click Here!
                </text>
              </svg>
            </Box>

            {/* <Box sx={{
                color: 'white',
                fontSize: '2vw',
                fontWeight: 'bold',
                position: 'absolute',
                top: '60%',
                left: '33%',
                transform: "rotate(330deg)",
                "-webkit-transform": "rotate(330deg)",
                "-moz-transform": "rotate(330deg)",
                "-ms-transform": "rotate(330deg=",
                backgroundColor: 'white',
                width: '100px',
                height: '50px'
              }}
              > */}
            {/* CLICK ME! */}
            {/* </Box> */}

            {/* <Box
                component="img"
                sx={{
                  width: circleSize * 0.6,
                  // boxShadow: 1,
                  borderRadius: 2,
                  cursor: "pointer",
                }}
                src={logoWithBrandmark}
              /> */}
            {/* <Typography
                sx={{
                  position: "relative",
                  top: 0,
                  left: 0,
                  color: "white",
                  fontSize: "large",
                  fontWeight: "bold",
                  transform: "rotate(330deg)",
                  "-webkit-transform": "rotate(330deg)",
                  "-moz-transform": "rotate(330deg)",
                  "-ms-transform": "rotate(330deg=",
                }}
                variant="body2"
                color="secondary"
              >
                CLICK ME!
              </Typography> */}
            {/* <Box marginTop={4}>
              <Button
                sx={{
                  animation: `${bounce} 1s ease infinite`,
                }}
                variant="outlined"
                color="secondary"
                // href="https://shop.ticketpay.de/77JOGMK4"
                onClick={e => {
                  e.stopPropagation();
                  window.open('https://shop.ticketpay.de/77JOGMK4');
                }}
                // target='_blank'
              >
                zu den Tickets
              </Button>
            </Box> */}
            {/* <Box marginTop={4}>
              <Button
                sx={{
                  // animation: `${bounce} 1s ease infinite`,
                }}
                variant="outlined"
                color="secondary"
                onClick={e => {
                  e.stopPropagation();
                  window.open(flyer2);
                }}
              >
                Mehr Infos
              </Button>
            </Box> */}
          </Box>
          {/* <Box sx={{ width: '300px', height: '100px', backgroundColor: 'green'}}>
              TEST
          </Box> */}
        </Box>
      </Box>
      {/* <Typography variant="body2" sx={{ color: '#00CC00'}}>
          coming soon July 2026 ...
        </Typography> */}
    </Box>
  );
}

export default function CircularStatic() {
  const [progress, setProgress] = React.useState(10);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 60 ? 0 : prevProgress + 1
      );
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return <CircularProgressWithLabel value={progress} />;
}
